export const iconFontAwesomeMedicalHealthPersonHalfDress = (
	<i className="fa-solid fa-person-half-dress"></i>
);
